/**
 * Utilitários para rastreamento de conversões do Google Ads
 * Modificado para usar a função global gtag_report_conversion injetada no index.html
 */

// Função auxiliar para disparar eventos de análise (mantendo histórico de analytics além da conversão)
const trackAnalyticsEvent = (eventName: string, params: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// Handler para cliques no telefone
export const handlePhoneClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  const url = e.currentTarget.href;
  e.preventDefault(); // Impede o comportamento padrão para permitir que o script de conversão controle a navegação

  console.log('📞 Phone click detected. URL:', url);

  // Mantém evento de analytics legado
  trackAnalyticsEvent('phone_call_click', {
    'event_category': 'engagement',
    'event_label': 'phone_call',
    'value': 1
  });

  if (typeof window !== 'undefined' && (window as any).gtag_report_phone_conversion) {
    // Usa o script de conversão de telefone global
    (window as any).gtag_report_phone_conversion(url);
  } else {
    // Fallback caso o script não esteja carregado
    console.warn('Script de conversão não encontrado, usando navegação padrão.');
    window.location.href = url;
  }
};

// Handler para cliques no WhatsApp
export const handleWhatsAppClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  const url = e.currentTarget.href;
  e.preventDefault(); // Impede o comportamento padrão

  console.log('💬 WhatsApp click detected. URL:', url);

  // Mantém evento de analytics legado
  trackAnalyticsEvent('whatsapp_click', {
    'event_category': 'engagement',
    'event_label': 'whatsapp_click',
    'value': 1
  });

  // A funcao de WhatsApp recai sozinha na conversao de lead nos sites que
  // ainda nao tem conversao propria, por isso o comportamento deles nao muda.
  if (typeof window !== 'undefined' && (window as any).gtag_report_whatsapp_conversion) {
    (window as any).gtag_report_whatsapp_conversion(url);
  } else if (typeof window !== 'undefined' && window.gtag_report_conversion) {
    window.gtag_report_conversion(url);
  } else {
    window.location.href = url;
  }
};

// Funções legadas mantidas vazias para evitar erros ifortunados em imports não detectados
// A lógica real agora reside nos handlers acima que possuem acesso ao URL
export const trackPhoneCall = () => {
  console.warn('trackPhoneCall() deprecated. Use handlePhoneClick(e).');
};

export const trackWhatsAppClick = () => {
  console.warn('trackWhatsAppClick() deprecated. Use handleWhatsAppClick(e).');
};
